import I18 from '_pixiSrc/I18';
import Sprite from '_pixiSrc/display/Sprite';
import { APP, ALIGN, VALIGN } from '_pixiSrc/globals';
import Static from '../libraries/Static';
import ScreenLocker from './ScreenLocker';
import GameConfig from '../libraries/GameConfig';
import DynamicData from './DynamicData';
import GameData from './GameData';

const symbolAssets = [
    'game/icons/Low_10_symbol',
    'game/icons/Low_J_symbol',
    'game/icons/Low_Q_symbol',
    'game/icons/Low_K_symbol',
    'game/icons/Low_A_symbol',
    'game/icons/Hi_05',
    'game/icons/Hi_04',
    'game/icons/Hi_03',
    'game/icons/Hi_02',
    'game/icons/Hi_01',
];
let background;

/**
 * @class PayoutsPopup
 * PayoutsPopup class manage symbol payout
 */
class PayoutsPopup extends Sprite {
    /**
   * @name invoke
   * @description display payout window
   */
    static invoke(parent, symbolType, callback) {
        /**
     * check payout popup is allow or not
     * if not allow then return false
     */
        if (!GameData.getProperty('isPPAllowed')) { return false; }
        if (this.isOpen) { return this.mainWindow; }

        this.mainWindow = parent.addChild(new ScreenLocker());
        this.mainWindow.position.set(0, 0);

        /**
     * set isPPOpen true
     */
        GameData.setProperty('isPPOpen', true);

        this.isOpen = true;
        this.symbolType = symbolType;

        this.callback = callback;

        /**
     * show payout window for symbol
     */
        this._showWindow(this.symbolType);

        this.mainWindow.on('pointerclick', () => this.close());

        return this.mainWindow;
    }

    /**
   * @name _showWindow
   * @description show payout window for symbol
   */
    static _showWindow(type) {
        if (!this.isOpen) { return; }

        background = this.mainWindow.addChild(APP.library.getSprite('payouts-popup/back'));

        background.scale.set(0.2);
        background.scaleTo(1, GameConfig.layoutFadeInOutTime);

        const symbol = background.addChild(APP.library.getSprite(symbolAssets[type]));
        symbol.scale._x = 0.8;
        symbol.scale._y = 0.8;
        symbol.position.set(-60, -10);

        if (type < 9) { printBlock(type, -10, -50); } else if (type === 9) {
            Static.writeText(background, I18.f('pp9H'), 'font_pay_table_05', 5, -40, {
                scale: 0.8,
                align: ALIGN.LEFT,
                valign: VALIGN.BOTTOM,
            });
            Static.writeNativeText(background, I18.f('pp9T1'), 'myriad', 5, -22, {
                fill: '#301e21',
                weight: 'bold',
                size: 10,
                wordWrap: true,
                wordWrapWidth: 100,
                align: ALIGN.LEFT,
                valign: VALIGN.BOTTOM,
            });
            Static.writeNativeText(background, I18.f('pp9T2'), 'myriad', 5, 8, {
                fill: '#301e21',
                weight: 'bold',
                size: 10,
                wordWrap: true,
                wordWrapWidth: 100,
                align: ALIGN.LEFT,
                valign: VALIGN.BOTTOM,
            });
        }

        /**
     * @name printBlock
     * @description get symbol payout and display that payout
     */
        function printBlock(symbolNumber, x, y, scaleCoef = 1) {
            const back = background.addChild(new Sprite());
            back.position.set(x, y);
            back.scaleTo(scaleCoef);

            /**
       * get symbol payout
       */
            const income = GameConfig.symbolIncome[symbolNumber].slice(0);
            const yPositions = income[0] === 0 ? [75, 55, 35, 15] : [65, 45, 25, 5];

            let maxSymbols = 0;
            for (let i = income.length - 1; i >= 0; i--) {
                const val = `${income[i] * DynamicData.getValue('bet')}`;
                if (val.length > maxSymbols) { maxSymbols = val.length; }
            }

            let fontSize = 23 - maxSymbols;

            if (fontSize > 16) { fontSize = 16; }
            if (fontSize < 6) { fontSize = 6; }

            const addY = Math.floor((16 - fontSize) / 2);

            /**
       * display payout data
       */
            for (let i = income.length - 1; i >= 0; i--) {
                const val = income[i] * DynamicData.getValue('bet');
                if (val) {
                    Static.writeText(back, 'X', 'font_pay_table_05', 8, yPositions[i] + 2, {
                        scale: 0.8,
                    });
                    Static.writeText(back, (i + 2), 'font_pay_table', 20, yPositions[i], {
                        scale: 0.6,
                    });
                    Static.writeNativeText(back, '•', 'myriad', 30, yPositions[i] - 6 + addY, {
                        fill: '#301e21',
                        weight: 'bold',
                        size: fontSize,
                        align: ALIGN.LEFT,
                        valign: VALIGN.BOTTOM,
                    });
                    Static.writeNativeText(back, val, 'myriad', 38, yPositions[i] - 6 + addY, {
                        fill: '#301e21',
                        weight: 'bold',
                        size: fontSize,
                        spaceDivider: true,
                        align: ALIGN.LEFT,
                        valign: VALIGN.BOTTOM,
                    });
                }
            }
            return back;
        }
    }

    /**
   * @name close
   * @description close payout popup
   */
    static close() {
        if (!this.isOpen) { return; }

        background.scaleTo(0.4, GameConfig.layoutFadeInOutTime, null, () => {
            GameData.setProperty('isPPOpen', false);
            this.isOpen = false;
            this.mainWindow.safeRemove();
            if (this.callback) { this.callback(); }
        });
    }
}

export default PayoutsPopup;
